import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { environment } from '@environments/environment';
import { AngularPaths, Consumer, LoginByTokenRequest } from '@models/index.model';
import { LoadingService, UserPinSessionService } from '@services/index.service';
import { finalize, map, Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class SsoUserPinGuard  {
  public isMobile: boolean;
  public currentConsumer: Consumer;

  public constructor(
    private _userPinSession: UserPinSessionService,
    private _router: Router,
    private _loading: LoadingService
  ) {
    this.currentConsumer = Consumer.GLOBAL_PERSONAL_AREA;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log('SsoUserPinGuard route - state: ', route, state);
    const tempToken: string = route.paramMap.get('tempToken');
    console.log('SsoUserPinGuard token: ', tempToken);
    // No tempToken is present. Redirect to default (Will be handled by DefaultRouteGuard).
    if (!tempToken) {
      return this._router.parseUrl(AngularPaths.DEFAULT);
    }
    const loginByTokenRequest: LoginByTokenRequest = { token: tempToken, consumer: this.currentConsumer };
    this._loading.showGlobalLoading();
    // TempToken is present and user dont have any session initialized.
    if (!this._userPinSession.checkTokenValid()) {
      return this._loginByToken(loginByTokenRequest).pipe(
        map(_ => false),
        finalize(() => this._loading.hideGlobalLoading())
      );
    }
  }

  private _loginByToken(loginByTokenRequest: LoginByTokenRequest) {
    return this._userPinSession.initTokenSession(loginByTokenRequest);
  }
}
